
import { ID, Icon, URL } from "src/libs/interfaces/layouts";
import { create } from "zustand";
import { createJSONStorage, devtools, persist } from "zustand/middleware";

export interface ILocalWorksStore {
    /* It's example. Clear this stroke. */
    exampleToDelete: string
}

export const useLocalWorksStore: any = create( 
    devtools( 
        persist<ILocalWorksStore>( 
            (set: any, get: any ) => ({ 
                /* It's example. Clear this stroke. */
                exampleToDelete: ""
            }),
            {
                name: 'pe-local-works-storage', 
                storage: createJSONStorage( () => localStorage ), 
            } 
        )
    )
)
